
// Basic
import PropTypes from 'prop-types';
// Components
import Entity from '@/common-utils/components/renders/entity/Entity';
import Icon from '@/common-utils/components/renders/icon/Icon';
import TooltipHelper from '@/common-utils/components/renders/tooltip/TooltipHelper';
// Common
import ICONS from '@/common-utils/enums/icons';
// Lang
import { nsSimCard } from '@/app/i18n/namespaces';

/**
 * @param root0
 * @param root0.cellData
 * @param root0.dataUnit
 * @param root0.tariffName
 * @param root0.nextOffer
 * @returns {JSX} RenderDataUnit
 */
function RenderDataUnit({ cellData, dataUnit, tariffName, nextOffer }) {
    return (
        <div className='flex items-center whitespace-nowrap'>
            <span>{cellData}</span>
            <Entity entity={`units.${dataUnit}`} namespace={nsSimCard} className='mx-1' />
            {
                tariffName ?
                    <span>{tariffName}</span>
                    : null
            }
            {
                nextOffer ?
                    <TooltipHelper
                        trigger={<Icon icon={ICONS.SIM_CARDS_OFFER_PENDING} />}
                        content={
                            <Entity
                                entity={
                                    nextOffer.shortDisplayName ?
                                        'next_offer.pending'
                                        : 'next_offer.pending_no_display_name'
                                }
                                namespace={nsSimCard}
                                data={nextOffer.shortDisplayName && { nextOffer: nextOffer.shortDisplayName }}
                            />
                        }
                        contentClass={'max-w-80 text-center'}
                    />

                    : null
            }
        </div>
    );
}

RenderDataUnit.propTypes = {
    cellData: PropTypes.number,
    dataUnit: PropTypes.string,
    tariffName: PropTypes.string,
    nextOffer: PropTypes.object
};
export default RenderDataUnit;